import React from "react";
import { Styled } from './styled'
import { StyledScreen } from "~common/screen";
import { DescriptionMobile } from "~/components/pages/features/components/description-mobile";

const Mobile = () => {

  const specifications = [
    {
      title: 'Приложение для звонков',
      text: ['Можно не покупать IP-телефон', 'Нет привязки к офису', 'Звонки фиксируются в АТС и CRM', 'Доступно везде, где есть интернет',
      'Стабильная связь — наше приложение имеет высшую оценку в App Store среди аналогов'],
      linkIOS: 'https://apps.apple.com/ru/app/onlinepbx/id1444397107',
      linkAndroid: 'https://play.google.com/store/apps/details?id=com.onlinepbx&hl=ru'
    },
    {
      title: 'Приложение администратора',
      text: ['Не нужен ПК для контроля звонков', 'Статистика по звонкам', 'Связь с техподдержкой',
        'Возможность быстро изменить настройки'],
      linkIOS: 'https://apps.apple.com/ru/app/onlinepbx-panel/id1551960264',
      linkAndroid: 'https://play.google.com/store/apps/details?id=com.onlinepbx.panel&hl=ru'
    }
  ]

  return (
    <Styled.Container>
      <Styled.Title>Мобильность и <StyledScreen.GreenText>экономия</StyledScreen.GreenText></Styled.Title>
      <Styled.Content>
        <DescriptionMobile link={'/features/calls'} title={specifications[0].title} text={specifications[0].text}
                           linkIOS={specifications[0].linkIOS} linkAndroid={specifications[0].linkAndroid}/>
        <Styled.ImageMobile src={`${process.env.PUBLIC_DIR}/images/features-page/mobile/mobile-app.svg`} />
      </Styled.Content>
      <Styled.ContentBlock>
        <Styled.Image src={`${process.env.PUBLIC_DIR}/images/features-page/mobile/admin-app.svg`} />
        <Styled.IndentAdmin/>
        <DescriptionMobile link={'/features/admin'} title={specifications[1].title} text={specifications[1].text}
                           linkIOS={specifications[1].linkIOS} linkAndroid={specifications[1].linkAndroid}/>
      </Styled.ContentBlock>
    </Styled.Container>
  )
}

export default Mobile
